import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  ButtonToggle,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  STATE_LIST,
  UPLOAD_FILE,
  UPDATE_ADMIN_USER,
  CREATE_ADMIN_USER,
  DECRYPT_PASSWORD_URL,
  CHANGE_PASSWORD,
  LOOKUP_BY_EMAIL_FOR_AGENCY,
} from "../../../constants/ApiPaths";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import moment from "moment";
import { authHeader, authUserRole } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { NUMBER_REGEX } from "../../../constants/ValidationRegex";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import Iconawesomeeye from "../../../images/eye.svg";
import Iconionicmdeyeoff from "../../../images/eye-slash.svg";
import { getAdminUserId } from "../../common/CommonFunctions";
// today
const today = new Date();
// validation schema
Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
  return this.test(`test-card-type`, errorMessage, function (value) {
    const { path, createError } = this;
    if (value) {
      let v1 = value;
      if (value.includes("+1 ")) {
        v1 = value.split("+1 ")[1];
      } else {
        // Handle the case where "+1 " is not present
        v1 = value;
      }

      var num = v1.replace(/\D+/g, "");
      var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
      let Pass = num.length <= 10;
      return (check && Pass) || createError({ path, message: errorMessage });
    } else {
      return createError({ path, message: "Phone Number is Required" });
    }
  });
});
const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email Required"),
  firstName: Yup.string().required("First Name Required"),
  lastName: Yup.string().required("Last Name Required"),
  phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),

  dateOfBirth: Yup.date()
    .required("Date Of Birth Required")
    .max(today, "Enter valid Date"),
  zip: Yup.string()
    .matches(NUMBER_REGEX, "Zip is not valid")
    .max(6, "Zip is not valid"),
  gender: Yup.string().required("Gender is required"),
  roleId: Yup.string().required("Role is required"),
});

export default function EmployeeEditModel(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    toggle,
    flag,
    modal,
    formData,
    Count,
    resetFormData,
    setCount,
    setflag,
    EmailEdit,
    className,
    oldPassword,
  } = props;

  const [lookupMail, setLookupMail] = useState("");

  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        console.log("success", response);
        // ps = response.data;
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const decryptPasswords = useCallback(async (data) => {
    try {
      let decryptedData = [];
      if (data.length > 0) {
        decryptedData = await Promise.all(
          data.map(async (item) => {
            const decryptedPassword = await getDecrypted(item.password);
            return { ...item, password: decryptedPassword };
          })
        );
      }
      return decryptedData;
    } catch (error) {
      console.error(error);
      // Handle error if needed
    }
  }, []);

  useEffect(() => {
    if (formData) {
      decryptPasswords(formData);
    }
  }, [formData, decryptPasswords]);

  const [SelectState, setSelectState] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const GetState = useCallback(async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      data: formData,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
      console.error(error);
    }
  }, [formData]);

  useEffect(() => {
    GetState();
  }, [GetState]);

  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    touched,
    setValues,
    errors,
    resetForm,
  } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => EmployeeEdit(values),
  });

  let EmployeeEdit = async () => {
    setLoading(true);
    const configpass = {
      method: "PUT",
      url: CHANGE_PASSWORD,
      data: {
        oldPassword: oldPassword,
        newPassword: values.password,
        email: values.email,
        hyperlink: window.location.host,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(configpass);
      const { status } = response.data;

      if (status === "Success") {
        console.log("success");
      }
    } catch (error) {
      console.log(error);
    }
    const config = {
      method: flag ? "POST" : "PUT",
      url: flag ? CREATE_ADMIN_USER : UPDATE_ADMIN_USER,
      data: {
        ...values,
        createdBy: getAdminUserId(),
        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        toggle();
        resetForm({});
        setCount(Count + 1);
        resetFormData();
        setPasswordShown(false);
        setflag(true);
        setLoading(false);
        CustomAlertMessage(
          flag ? "New Employee Created" : "Details Updated Successfully",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      let { data } = error.response;
      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };

  let Change = async (e) => {
    const selectedFile = e.target.files[0];
    setLoading(true);
    if (selectedFile) {
      const formDatas = new FormData();
      formDatas.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDatas,
        headers: authHeader(),
      };
      try {
        const response = await API(config);
        const { status, filepath } = response.data;
        if (status === "Success") {
          setValues({ ...values, profileImage: filepath });
        }
        // setprofileFlag(false);
        setLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };
  let DeleteProfile = () => {
    setValues({ ...values, profileImage: "" });
  };
  let Profile = () => {
    const image = values.profileImage;
    if (image) {
      return image;
    } else {
      return ProfileAvatar;
    }
  };
  const lookUpFun = async () => {
    console.log("called", lookupMail);
    if (lookupMail !== "") {
      const config = {
        method: "GET",
        url: LOOKUP_BY_EMAIL_FOR_AGENCY,
        params: {
          email: lookupMail,
        },
      };
      try {
        const response = await API(config);
        console.log(response.data.data[0]);
        const {
          address,
          city,
          dateOfBirth,
          email,
          firstName,
          gender,
          lastName,
          password,
          phoneNumber,
          stateId,
          zip,
          roleId,
        } = response.data.data[0];
        let decryptedPassword;
        if (password !== "") {
          decryptedPassword = await getDecrypted(password);
          setValues({ ...values, password: decryptedPassword });
        }
        setValues({
          firstName,
          lastName,
          email,
          password: decryptedPassword,
          phoneNumber,
          address,
          stateId,
          city,
          zip,
          roleId,
          dateOfBirth,
          gender,
        });
      } catch (error) {
        if (error) {
          const { message } = error.response.data;
          CustomAlertMessage(message, "error", enqueueSnackbar);
        }
        console.error(error);
      } finally {
        // setLoading(false);
      }
    } else {
      CustomAlertMessage("Please enter email", "error", enqueueSnackbar);
    }
  };
  const handleChangeFun = (e) => {
    setLookupMail(e.target.value);
  };
  return (
    <div>
      {Loading && <CustomPageLoading />}
      <Modal
        size="lg"
        isOpen={modal}
        toggle={() => {
          resetForm({});
          setPasswordShown(false);
          setLookupMail("");

          toggle();
        }}
        className={className}
      >
        <Form form="true" onSubmit={handleSubmit}>
          <ModalHeader
            toggle={() => {
              resetForm({});
              setPasswordShown(false);
              setLookupMail("");
              toggle();
            }}
          >
            {flag ? "Create Employee" : "Update Employee"}
          </ModalHeader>
          <ModalBody>
            <div className="user-box">
              <img value={values.profileImage} src={Profile()} alt="" />
              <p>Employee Profile</p>
              {!values.profileImage ? (
                <div className="upload-btn-wrapper">
                  <button className="upload-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.407"
                      height="16.981"
                      viewBox="0 0 19.407 16.981"
                    >
                      <path
                        id="Icon_awesome-camera"
                        data-name="Icon awesome-camera"
                        d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                        transform="translate(0 -2.25)"
                        fill="#d51d1d"
                      />
                    </svg>
                  </button>
                  <Input type="file" name="profileImage" onChange={Change} />
                </div>
              ) : (
                <div className="upload-btn-wrapper">
                  <Button
                    onClick={DeleteProfile}
                    className="table-btn"
                    color="link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10.071"
                      height="12.949"
                      viewBox="0 0 10.071 12.949"
                    >
                      <path
                        id="Icon_material-delete"
                        data-name="Icon material-delete"
                        d="M8.219,16.01a1.443,1.443,0,0,0,1.439,1.439h5.755a1.443,1.443,0,0,0,1.439-1.439V7.378H8.219ZM17.571,5.219H15.054L14.334,4.5h-3.6l-.719.719H7.5V6.658H17.571Z"
                        transform="translate(-7.5 -4.5)"
                        fill="#c72e39"
                      />
                    </svg>
                  </Button>{" "}
                </div>
              )}
            </div>
            {flag ? (
              <>
                <Row xs="12">
                  <Col xs="6">
                    <FormGroup>
                      <Label for="">Email</Label>
                      <Input
                        type="email"
                        value={lookupMail}
                        onBlur={handleBlur}
                        // disabled={Emaildisable}
                        // invalid={errors.email && touched.email ? true : false}
                        onChange={handleChangeFun}
                        id=""
                        placeholder="Enter email"
                      />
                      {/* <FormFeedback>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormFeedback> */}
                    </FormGroup>
                  </Col>
                  <Col xs="6">
                    <ButtonToggle
                      style={{ marginTop: "30px" }}
                      // form={`endUserWebForm_${currentStep}`}
                      // type="submit"
                      color="primary"
                      onClick={lookUpFun}
                    >
                      {/* {loading && <CustomButtonLoader loading={loading} />} */}

                      {"Look Up"}
                    </ButtonToggle>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            <Row xs="12">
              <Col xs="6">
                <FormGroup>
                  <Label for="">First Name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    value={values.firstName}
                    onBlur={handleBlur}
                    invalid={
                      errors.firstName && touched.firstName ? true : false
                    }
                    onChange={handleChange}
                    id=""
                    placeholder="Enter First Name"
                  />
                  <FormFeedback>
                    {errors.firstName && touched.firstName
                      ? errors.firstName
                      : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    value={values.email}
                    onBlur={handleBlur}
                    disabled={EmailEdit}
                    invalid={errors.email && touched.email ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Email"
                  />
                  <FormFeedback>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="">Date of Birth</Label>
                  <Input
                    type="date"
                    name="dateOfBirth"
                    value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
                    onBlur={handleBlur}
                    invalid={
                      errors.dateOfBirth && touched.dateOfBirth ? true : false
                    }
                    onChange={handleChange}
                    placeholder="Date of Birth"
                    id=""
                  />
                  <FormFeedback>
                    {errors.dateOfBirth && touched.dateOfBirth
                      ? errors.dateOfBirth
                      : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="">Address</Label>
                  <Input
                    type="text"
                    name="address"
                    value={values.address}
                    onBlur={handleBlur}
                    invalid={errors.address && touched.address ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Your Address"
                  />
                  <FormFeedback>
                    {errors.address && touched.address ? errors.address : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="">Zip</Label>
                  <Input
                    type="text"
                    name="zip"
                    value={values.zip}
                    onBlur={handleBlur}
                    invalid={errors.zip && touched.zip ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Zip Code"
                  />
                  <FormFeedback>
                    {errors.zip && touched.zip ? errors.zip : ""}
                  </FormFeedback>
                </FormGroup>
                {!flag ? (
                  <FormGroup>
                    <Label for="">State</Label>

                    <Input
                      type="select"
                      name="stateId"
                      value={values.stateId}
                      onBlur={handleBlur}
                      invalid={errors.stateId && touched.stateId ? true : false}
                      onChange={handleChange}
                      id=""
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateId}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>
                      {errors.stateId && touched.stateId ? errors.stateId : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  <></>
                )}
                {flag ? (
                  <FormGroup>
                    <Label for="exampleSelect">Role</Label>
                    <Input
                      type="select"
                      name="roleId"
                      onBlur={handleBlur}
                      value={values.roleId}
                      invalid={errors.roleId && touched.roleId ? true : false}
                      onChange={handleChange}
                      id="exampleSelect"
                    >
                      <option value="">Select Role</option>
                      {authUserRole() === "Root Admin" && (
                        <option value="1">Admin</option>
                      )}
                      <option value="2">Employee</option>
                    </Input>
                    <FormFeedback>
                      {errors.roleId && touched.roleId ? errors.roleId : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  ""
                )}
              </Col>
              <Col xs="6">
                <FormGroup>
                  <Label for="">Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    value={values.lastName}
                    onBlur={handleBlur}
                    invalid={errors.lastName && touched.lastName ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Last Name"
                  />
                  <FormFeedback>
                    {errors.lastName && touched.lastName ? errors.lastName : ""}
                  </FormFeedback>
                </FormGroup>
                {!flag ? (
                  <FormGroup>
                    <Label for="">Password</Label>
                    <InputGroup>
                      <Input
                        type={passwordShown ? "text" : "password"}
                        name="password"
                        value={values.password}
                        onBlur={handleBlur}
                        invalid={
                          errors.password && touched.password ? true : false
                        }
                        onChange={handleChange}
                        id=""
                        placeholder="Enter password"
                      />
                      <>
                        <InputGroupText
                          onClick={togglePassword}
                          style={{ cursor: "pointer" }}
                        >
                          {passwordShown ? (
                            <img src={Iconawesomeeye} alt="" />
                          ) : (
                            <img src={Iconionicmdeyeoff} alt="" />
                          )}
                        </InputGroupText>
                      </>
                    </InputGroup>
                    <FormFeedback>
                      {errors.email && touched.email ? errors.email : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  <></>
                )}
                <FormGroup>
                  <Label for="">Phone Number</Label>
                  <Input
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onBlur={handleBlur}
                    invalid={
                      errors.phoneNumber && touched.phoneNumber ? true : false
                    }
                    onChange={handleChange}
                    id=""
                    placeholder="Enter Phone Number"
                  />
                  <FormFeedback>
                    {errors.phoneNumber && touched.phoneNumber
                      ? errors.phoneNumber
                      : ""}
                  </FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="">Gender</Label>
                  <Input
                    type="select"
                    name="gender"
                    value={values.gender}
                    onBlur={handleBlur}
                    invalid={errors.gender && touched.gender ? true : false}
                    onChange={handleChange}
                    id=""
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </Input>
                  <FormFeedback>
                    {errors.gender && touched.gender ? errors.gender : ""}
                  </FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="">City</Label>
                  <Input
                    type="text"
                    name="city"
                    value={values.city}
                    onBlur={handleBlur}
                    invalid={errors.city && touched.city ? true : false}
                    onChange={handleChange}
                    id=""
                    placeholder="Enter City Name"
                  />
                  <FormFeedback>
                    {errors.city && touched.city ? errors.city : ""}
                  </FormFeedback>
                </FormGroup>
                {flag ? (
                  <FormGroup>
                    <Label for="">State</Label>

                    <Input
                      type="select"
                      name="stateId"
                      value={values.stateId}
                      onBlur={handleBlur}
                      invalid={errors.stateId && touched.stateId ? true : false}
                      onChange={handleChange}
                      id=""
                    >
                      <option value="">Select State</option>
                      {SelectState.map((i) => (
                        <option key={i.stateId} value={i.stateId}>
                          {i.stateName}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>
                      {errors.stateId && touched.stateId ? errors.stateId : ""}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" block>
              {flag ? "ADD" : "Update"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}
